import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { StringUtilsService } from '../../../../../core/services/string-utils.service';
import { ContactRelationshipsService } from '../../../../../core/lists';
import { Entity, EntityType } from '../../models';
import { EntityType as Type } from '../../enums';
import { GeneralAutocompleteComponent } from '../../../../partials/layout/general-autocomplete/general-autocomplete.component';

@Component({
  selector: 'kt-assign-entity',
  templateUrl: './assign-entity.component.html',
})
export class AssignEntityComponent implements AfterViewInit {
  entityTypes = Object.values(Type);
  getEntityAutocomplete;
  @ViewChild('entityTypeSelect') entityTypeSelect: MatSelect;
  @ViewChild('entityAutocomplete') entityAutocomplete: GeneralAutocompleteComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { entityTypes: EntityType[]; entities: Entity[] },
    public stringUtils: StringUtilsService,
    private dialogRef: MatDialogRef<AssignEntityComponent>,
    private relationshipsService: ContactRelationshipsService,
  ) {}

  ngAfterViewInit(): void {
    this.getEntityAutocomplete = this.relationshipsService.findEntities.bind(
      this.relationshipsService,
      {
        entityTypes: this.data.entityTypes,
      },
    );

    this.entityTypeSelect.value = this.data.entityTypes || [];
    this.entityAutocomplete.setValue(this.data.entities || []);
    this.entityAutocomplete.updateValueAndValidity();
  }

  formatNewEntity(entity: Entity): Entity {
    return entity;
  }

  closeDialog(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close();
  }

  submit(event: Event): void {
    event.stopPropagation();

    this.dialogRef.close({ entities: this.entityAutocomplete.value });
  }
}
